export default __webpack_public_path__ + "static/media/00en.54a01ae3.mp3";